<template>
  <v-container>
    <v-row v-if="error">
      <v-col
        cols="12"
        sm="6"
        offset-sm="3"
      >
        <app-alert
          :text="error.message"
          @dismissed="onDismissed"
        ></app-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        offset-sm="3"
      >
        <v-card>
          <v-card-text>
            <v-container>
              <form @submit.prevent="onSignin">
                <validation-observer
                  ref="observer"
                  v-slot="{ invalid }"
                >
                  <v-row>
                    <v-col cols="12">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Email"
                        rules="required|email"
                      >
                        <v-text-field
                          id="email"
                          v-model="email"
                          name="email"
                          label="Email"
                          type="email"
                          required
                          outlined
                          prepend-inner-icon="mdi-email-outline"
                          :error-messages="errors"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <validation-provider
                        v-slot="{ errors }"
                        vid="password"
                        name="Password"
                        rules="required"
                      >
                        <v-text-field
                          id="password"
                          v-model="password"
                          name="password"
                          label="Password"
                          required
                          outlined
                          :type="show ?'text':
                            'password'"
                          :append-icon="show ?'mdi-eye-outline':'mdi-eye-off'"
                          prepend-inner-icon="mdi-lock"
                          :error-messages="errors"
                          @click:append="show=!show"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <button
                      text
                      class="primary--text"
                      @click="forgotPassword()"
                    >
                      Forgot Password?
                    </button>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-btn
                        class="primary whtie--text mr-0 login-btn-new cta-button download-button"
                        block
                        large
                        style="text-transform: none;"
                        type="submit"
                        :disabled="loading || invalid"
                      >
                        Sign In
                      </v-btn>
                    </v-col>
                  </v-row>
                </validation-observer>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        email: '',
        password: '',
        show: false,
      }
    },
    computed: {
      user () {
        return this.$store.getters.user
      },
      error () {
        return this.$store.getters.error
      },
      loading () {
        return this.$store.getters.loading
      }
    },
    watch: {
      user (value) {
        if (value !== null && value !== undefined) {
          this.$router.push('/')
        }
      }
    },
    methods: {
      onSignin () {
        this.$store.dispatch('signUserIn', { email: this.email, password: this.password })
        // trackEvent({
        //   event: 'Sign In Button Hit',
        //   event_category: 'Button Clicks',
        //   event_action: 'Click',
        //   event_label: 'User Signed In'
        // })
      },
      onDismissed () {
        this.$store.dispatch('clearError')
      },
      forgotPassword () {
        this.$store.dispatch('clearError')
        this.$router.push({ path: '/forgotpassword' })
      },
    }
  }
</script>

<style scoped>
.cta-button {
  padding: 10px 40px; /* Increased horizontal padding */
  border: none;
  border-radius: 5px;
  font-size: 18px; /* Slightly larger font size */
  cursor: pointer;
  transition: background-color 0.3s;
  min-width: 150px; /* Minimum width */
  background-color: #4CAF50; /* Green */
  color: white;
}

.cta-button:hover {
  opacity: 0.9;
}
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
